export var Roles;
(function (Roles) {
    Roles["Admin"] = "ADMIN";
    Roles["Manager"] = "MANAGER";
    Roles["User"] = "USER";
    Roles["Employee"] = "EMPLOYEE";
})(Roles || (Roles = {}));
//# sourceMappingURL=user-role.js.map